import React from 'react';

export const Card = ({ children, className = '', title, action }) => {
  return (
    <div className={`bg-slate-900/80 backdrop-blur-sm panel-border neon-border rounded-sm flex flex-col ${className}`}>
      {(title || action) && (
        <div className="flex justify-between items-center px-4 py-3 border-b border-slate-800/80">
          {title && <h3 className="text-sm font-medium tracking-wider text-slate-300 uppercase">{title}</h3>}
          {action && <div>{action}</div>}
        </div>
      )}
      <div className="flex-1 p-4">
        {children}
      </div>
    </div>
  );
};